import { LivePlayer } from "@/components/live";
import { LiveDetailData } from "@/types";
import { TrackData } from "@akc/taro-service";
import React, { useEffect, useRef } from "react";
import styles from "./index.module.less";

interface Props {
  liveDetail: LiveDetailData;
  trackData?: TrackData;
  // 上报直播视频背景大卡曝光状态，false表示曝光，true表示未曝光
  setShowSmallWindow?: (show: boolean) => void;
}

// 直播背景大卡
const LiveBigCard: React.FC<Props> = ({ liveDetail, trackData, setShowSmallWindow }) => {
  const liveBigCardRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const node = liveBigCardRef.current;
    if (!node) {
      return;
    }

    // 创建 IntersectionObserver 实例
    const observer = new window.IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 进入视口
            setShowSmallWindow?.(false);
          } else {
            // 离开视口
            setShowSmallWindow?.(true);
          }
        });
      },
      {
        root: null, // 视口
        threshold: 0, // 只要有一丁点可见就算进入
      },
    );

    observer.observe(node);

    // 清理
    return () => {
      observer.disconnect();
    };
  }, [liveDetail, setShowSmallWindow]);

  return (
    <>
      {liveDetail ? (
        <div ref={liveBigCardRef} className={styles.live_big_card}>
          <LivePlayer
            roomId={liveDetail.liveNo}
            className={styles.live}
            muted={true}
            onError={error => {
              console.log("播放器报错", error);
            }}
            poster={liveDetail.coverUrl}
            src={liveDetail?.pullStreamUrl?.httpsM3u8Url}
            supportClick={false}
            mutedVisible={true}
            showPlayBtn={true}
            trackData={trackData}
            liveInfo={{
              liveStatus: liveDetail?.liveStatus,
              liveNo: liveDetail?.liveNo,
              liveTitle: liveDetail?.liveTitle,
              liveType: liveDetail?.liveType,
            }}
          />
          <div className={styles.card__footer}>
            <div className={styles.footer__tips}>
              <img
                className={styles.tips__icon}
                src="https://akim-oss.aikucun.com/mshop/1db67b528a43de2bebca495a6b1a0ef4931e3316_1750211419152_73.png"
                alt=""
              />
              <span>下拉进入直播间</span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default React.memo(LiveBigCard, (prevProps, nextProps) => {
  return (
    prevProps.liveDetail?.liveNo === nextProps.liveDetail?.liveNo &&
    prevProps.liveDetail?.liveStatus === nextProps.liveDetail?.liveStatus &&
    prevProps.liveDetail?.coverUrl === nextProps.liveDetail?.coverUrl &&
    prevProps.liveDetail?.pullStreamUrl?.httpM3u8Url ===
      nextProps.liveDetail?.pullStreamUrl?.httpM3u8Url
  );
});
